import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02f0072c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "confirm-password-modal" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "title" }, "Confirm Password", -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "To do this, first you need to confirm your password.", -1));
const _hoisted_4 = ["onSubmit"];
const _hoisted_5 = ["for"];
const _hoisted_6 = { class: "flex flex-row justify-between" };
const _hoisted_7 = /*#__PURE__*/ _createTextVNode(" Cancel ");
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Confirm Password", -1));
import { ChevronRightIcon, KeyIcon } from "@heroicons/vue/outline";
import { provideConfirmPasswordModal, useErrorHandling } from "@/helpers";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import Modal from "@/components/Modal.vue";
import { ref } from "vue";
import { useAuthentication } from "@/stores/authentication";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const cpm = provideConfirmPasswordModal();
        const { errors, handleError } = useErrorHandling(cpm.showModal);
        const authStore = useAuthentication();
        const password = ref();
        const loading = ref();
        const submit = async () => {
            try {
                loading.value = true;
                await authStore.confirmPassword(password.value ?? "");
                loading.value = false;
                cpm.closeModal(true);
            }
            catch (err) {
                loading.value = false;
                await handleError(err);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _renderSlot(_ctx.$slots, "default"),
                _createVNode(Modal, {
                    importance: "critical",
                    show: _unref(cpm).confirmPasswordModal.value,
                    "onUpdate:show": _cache[2] || (_cache[2] = ($event) => ((_unref(cpm).confirmPasswordModal.value) = $event))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _hoisted_2,
                            _hoisted_3,
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(submit, ["prevent"])
                            }, [
                                _createVNode(Input, {
                                    autocomplete: "username",
                                    type: "hidden"
                                }),
                                _createVNode(Input, {
                                    errors: _unref(errors).errors?.password,
                                    autocomplete: "current-password",
                                    type: "password",
                                    modelValue: password.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((password).value = $event))
                                }, {
                                    label: _withCtx(({ forId }) => [
                                        _createElementVNode("label", {
                                            class: "sr-only",
                                            for: forId
                                        }, "Password", 8, _hoisted_5)
                                    ]),
                                    icon: _withCtx(() => [
                                        _createVNode(_unref(KeyIcon), { class: "icon" })
                                    ]),
                                    _: 1
                                }, 8, ["errors", "modelValue"]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(Button, {
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_unref(cpm).closeModal(false)), ["prevent"])),
                                        type: "button",
                                        variant: "grey"
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_7
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(Button, {
                                        type: "submit",
                                        variant: "light"
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_8,
                                            _createVNode(_unref(ChevronRightIcon), { class: "icon" })
                                        ]),
                                        _: 1
                                    })
                                ])
                            ], 40, _hoisted_4)
                        ])
                    ]),
                    _: 1
                }, 8, ["show"])
            ], 64));
        };
    }
});
